import { useTranslation } from "react-i18next";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import AssetManager from "../../../../common/AssetManager";
import {
  Clothes,
  Material,
  Palette,
} from "../../../../context/suggestionContext/suggestionTypes";

import { useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { SwiperClass } from "swiper/react";
import KartonModal from "../../../../common/components/KartonModal";
import MaterialIcons from "../../../../common/components/MaterialIcons";
import WikiModal from "../../../../common/components/WikiModal";
import useResolvedLang from "../../../../common/hooks/useResolvedLang";
import { CombinationSuggestion } from "../../../../context/suggestionContext/types";

const SuggestedClothesCarouselComponent: React.FC<
  SuggestedClothesCarouselComponentProps
> = ({
  clothesForLayer,
  materials,
  palettes,
  changeActiveLayer,
  activeLayerIndex,
  activeLayers,
  activeCombination,
}) => {
  const [swiper, setSwiper] = useState<SwiperClass | null>(null);

  const { i18n } = useTranslation();

  const [wikiOpen, setWikiOpen] = useState<boolean>(false);
  const [wikiIDList, setWikiIDList] = useState<number[]>([]);
  const [kartonOpen, setKartonOpen] = useState<boolean>(false);

  const lang = useResolvedLang();

  useEffect(() => {
    if (swiper) {
      swiper.slideTo(activeLayers[activeLayerIndex], 0, false);
    }
  }, [activeLayerIndex]);

  useEffect(() => {
    const activeClothes = clothesForLayer[activeLayerIndex];

    if (activeClothes) {
      const material = materials.find(
        (material) =>
          material.materialId.toString() === activeClothes.materialId
      );

      if (material) {
        setWikiIDList([
          ...material?.wikiIDList,
          ...activeClothes.wikiIDList,
          activeCombination ? activeCombination.wikiID ?? -1 : -1,
        ]);
      }
    } else {
      setWikiIDList([]);
    }
  }, [clothesForLayer, activeLayerIndex]);

  function getMaterial(id: string): Material | undefined {
    return materials.find((material) => material.materialId.toString() === id);
  }

  function getTranslationForKey(key: string) {
    const translation = i18n.t(key);

    return translation;
  }

  return (
    <div className="suggested-clothes-card">
      <Swiper
        modules={[Navigation, Pagination]}
        navigation
        pagination
        slidesPerView={1}
        onSwiper={(sw) => {
          setSwiper(sw);
        }}
        onSlideChange={(swiper) => {
          changeActiveLayer(activeLayerIndex, swiper.activeIndex);
        }}
        initialSlide={activeLayers[activeLayerIndex]}
        direction="horizontal"
      >
        {clothesForLayer.map((value, index) => (
          <SwiperSlide key={index} className="suggested-clothes-slider">
            <img
              src={AssetManager.getAsset(value.availablePalettes[0].imageUrl)}
              alt={i18n.t(value.clothNameKey) ?? "Cloth image"}
              className="suggested-clothes-image"
            />

            {clothesForLayer[activeLayers[activeLayerIndex]].clothDetailsImages[
              lang
            ] && (
              <div
                className="suggested-clothes-info-container"
                onClick={() => setKartonOpen(true)}
              >
                <img
                  src={AssetManager.getAsset("/suggestions_info.svg")}
                  alt="Info"
                  className="suggested-clothes-info-icon"
                />
              </div>
            )}

            <div className="suggested-clothes-details">
              <p className="suggested-clothes-name">
                {i18n.t(value.clothNameKey)}
              </p>
              <div className="suggested-clothes-material-details">
                <p className="suggested-clothes-material-name">
                  {i18n.t(
                    getMaterial(value.materialId)?.materialNameKey ?? "Material"
                  )}
                </p>
                <p className="suggested-clothes-material-composition">
                  {getTranslationForKey(
                    getMaterial(value.materialId)?.compositionNameKey ??
                      "Composition"
                  )}
                </p>
                <MaterialIcons
                  material={getMaterial(value.materialId)}
                ></MaterialIcons>
              </div>
              {/* <div className="suggested-clothes-palettes">
                {value.availablePalettes.map((palette, i) => {
                  return (
                    <CustomPaletteButton
                      key={i}
                      isActive={i == 0}
                      color={
                        palettes.find((p) => p.paletteId === palette.paletteId)
                          ?.color ?? "#D5BCA1"
                      }
                      onClick={() => console.log(palette)}
                    ></CustomPaletteButton>
                  );
                })}
              ADD LOGIC TO SWITCH PALETTE
              </div> */}

              {value.link && (
                <a
                  href={value.link}
                  className="suggestion-buy-now"
                  target="_blank"
                >
                  {i18n.t("buy_now")}
                </a>
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      {wikiOpen && (
        <WikiModal
          open={wikiOpen}
          setOpen={setWikiOpen}
          wikiIDList={wikiIDList}
        ></WikiModal>
      )}
      {kartonOpen && (
        <KartonModal
          open={kartonOpen}
          setOpen={setKartonOpen}
          kartonImageUrl={AssetManager.getGarmentInfoAssets(
            clothesForLayer[activeLayers[activeLayerIndex]].clothDetailsImages[
              lang
            ]!
          )}
          clothName={i18n.t(
            clothesForLayer[activeLayers[activeLayerIndex]].clothNameKey
          )}
        ></KartonModal>
      )}
    </div>
  );
};

export default SuggestedClothesCarouselComponent;

export interface SuggestedClothesCarouselComponentProps {
  clothesForLayer: Clothes[];
  materials: Material[];
  palettes: Palette[];
  activeLayerIndex: number;
  activeLayers: number[];
  changeActiveLayer(layerIndex: number, activeIndex: number): void;
  activeCombination: CombinationSuggestion | null;
}
